'use client';
import { type ComponentPropsWithoutRef, forwardRef, type KeyboardEvent } from 'react';
import { CODE, KEY } from './hooks/keyboard.constants';

export interface ClickableProps extends ComponentPropsWithoutRef<'div'> {
  onClick: () => void;
}

export const Clickable = forwardRef<HTMLDivElement, ClickableProps>(function Clickable(
  { children, onClick, ...attrs },
  ref,
) {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (
      e.key === KEY.ENTER ||
      e.key === KEY.SPACE ||
      e.code === CODE.ENTER ||
      e.code === CODE.SPACE
    ) {
      onClick();
    }
  };

  return (
    <div
      {...attrs}
      data-name="Clickable"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      ref={ref}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
});
